// Imports
import currency from 'currency.js';
import planMapping from '../billing/plan-mapping';
import subscriptionAmountMapping from './subscription-amount-mapping';
import extendedPricingDetails from './extended-pricing-details';


/** Shareable to determine monthly cost of a subscription at a given size */
export default function determineMonthlySubscriptionAmount(options: {
	plan: (typeof planMapping)[keyof typeof planMapping];
	size: number;
	yearly: boolean;
}) {
	// Free plan is always free
	if (options.plan === planMapping.free) {
		return currency(0);
	}
	
	
	// Retrieve extended pricing details
	const extendedPricing = options.plan in extendedPricingDetails ? extendedPricingDetails[options.plan] : null;
	
	
	// Handle extended pricing
	if (extendedPricing && options.size > extendedPricing.start && options.size <= extendedPricing.end) {
		// Initialize
		const accounts = Math.ceil(options.size / extendedPricing.step) * extendedPricing.step;
		let counted = 0;
		
		
		// Handle invalid sizes
		if (accounts !== options.size) {
			throw new Error('Plan does not support this size');
		}
		
		
		// Determine base monthly amount per accounts for a yearly subscription
		const amount = Object.entries(extendedPricing.tiers).reduce((acc, [size, amount]) => {
			const take = Math.min((parseInt(size) || Number.MAX_SAFE_INTEGER) - counted, accounts - counted);
			counted += take;
			return acc.add(amount.multiply(take));
		}, currency(0));
		
		
		// Determine discounted amount
		const discountedAmount = currency(amount).divide(options.yearly ? 1 : 0.9);
		
		
		// Return rounded amount
		return discountedAmount
			.add(discountedAmount.cents() > 0 ? 1 : 0)
			.subtract(currency(discountedAmount.cents(), { fromCents: true }));
	}
	
	
	// Retrieve plan subscription amount
	const amount = subscriptionAmountMapping[options.plan]?.[options.size];
	
	if (!amount) {
		throw new Error('Plan does not support this size');
	}
	
	
	// Handle base monthly plan type
	if (options.plan === planMapping.deluxe) {
		// Return discounted amount
		return currency(amount).multiply(options.yearly ? 0.9 : 1);
	}
	
	
	// Determine discounted amount
	const discountedAmount = currency(amount).divide(options.yearly ? 1 : 0.9);
	
	
	// Return rounded amount
	return discountedAmount
		.add(discountedAmount.cents() > 0 ? 1 : 0)
		.subtract(currency(discountedAmount.cents(), { fromCents: true }));
}
